import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { useHideElements, useSceneElement } from '@editor/hooks'
import { FoundationSchema } from '../FoundationForm/schema'
import FoundationSceneElement from '../FoundationSceneElement'

interface Props {
  guid: string
}

const FoundationScene = ({ guid }: Props) => {
  useHideElements(guid)

  const points = useWatch<FoundationSchema>({ name: 'points' })

  const sceneElement = useMemo(
    () => ({
      enabled: true,
      properties: {
        points: points as { x: number; y: number; z: number }[],
      },
      component: FoundationSceneElement,
    }),
    [points],
  )

  useSceneElement(sceneElement)

  return null
}

export default FoundationScene
